/**
 * Converts ISO/PostgreSQL timestamp string to 'Month Day, Year' (e.g., 'Nov 05, 2025').
 * Removes time/timezone for clean UI display.
 */
export const formatSimpleDate = (isoString) => {
  if (!isoString) return 'N/A';

  try {
    let dateInput = isoString;
    if (typeof isoString === 'string') {
      // Preserve timezone offsets that Supabase/Postgres already returns.
      if (!isoString.includes('T')) {
        dateInput = isoString.replace(' ', 'T');
      }

      const hasTimezoneOffset = /([zZ]|[+-]\d{2}:?\d{2})$/.test(dateInput);
      if (!hasTimezoneOffset) {
        dateInput += 'Z';
      }
    }

    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return 'Invalid Date';

    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
    }).format(date);
  } catch (error) {
    console.error('formatSimpleDate error:', error, 'Input:', isoString);
    return 'Date Error';
  }
};

export const getLocalDateKey = (input = new Date()) => {
  const date = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(date.getTime())) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};